// Be mindful of the z-indexes that Material UI (mui) uses.
// https://mui.com/material-ui/customization/z-index/
//
// mobile stepper: 1000
// fab: 1050
// speed dial: 1050
// app bar: 1100
// drawer: 1200
// modal: 1300
// snackbar: 1400
// tooltip: 1500

// Note these might make more sense to go into designer theme package in future.
export const zIndexes = {
  errorDialog: 2000,

  importToaster: 1000,
  shield: 1000,

  propertiesPanelPopover: 603,
  colorPickerPopover: 603,

  triggersOverlayPopover: 602,
  triggersOverlaySidebar: 601,
  triggersOverlay: 600,

  applicationToolbar: 500,
  activitySlotToolbar: 500,
  composableInterlude: 500,

  composablePanel: 410,
  composableNavigationBar: 409,

  composableNodeDropIndicator: 405,
  composableNodeControlsBar: 404,
  canvasSnapGuide: 403,
  composableNodeBorderSelected: 401,
  composableNodeBorderHovered: 400,
  composableNodeBorderLayout: 399,

  mainSidebar: 10,
};
